import { useState, useEffect, useRef } from 'react';
import RateStar from './RateStar/RateStar';
import css from './Stars.module.scss';
import classNames from 'classnames';
import { calcValueOnTouch } from './helpers';

const Stars = ({ disabled, value, attribute, setVal, setFormData, options, size = 34 }) => {
    const isReadOnly = disabled || !setVal || !setFormData;
    function roundDownWithStep(number) {
        if (!number) return;
        return Math.floor(number / 0.5) * 0.5;
    }
    const [hover, setHover] = useState(roundDownWithStep(value));

    const rateList = [1, 2, 3, 4, 5];

    const starsWrapper = useRef();

    useEffect(() => {
        setHover(roundDownWithStep(value) || 0);
    }, [value]);

    const activeTitleIndex = rateList.findIndex((item) => item === Math.ceil(value));
    const activeTitle = options ? options[activeTitleIndex] : false;

    return (
        <div
            className={classNames(css.ratingBlock, options?.length ? css.ratingBlock_mdCenter : '')}
            onMouseLeave={() => {
                if (!isReadOnly) {
                    setHover(value);
                }
            }}
        >
            <div
                ref={starsWrapper}
                onTouchMove={(e) => {
                    if (!isReadOnly && starsWrapper.current) {
                        const selectedValue = calcValueOnTouch(starsWrapper.current, e, rateList.length);
                        setHover(selectedValue);
                    }
                }}
                onTouchEnd={() => {
                    setVal(hover);
                    setFormData(attribute, hover);
                }}
                style={{ margin: `0 -${size / 3 / 2}px` }}
                className={classNames(css.ratingList, options?.length ? css.ratingList_mdCenter : '')}
            >
                {rateList.map((item, i) => (
                    <RateStar
                        size={size}
                        key={item}
                        item={item}
                        attribute={attribute}
                        isReadOnly={isReadOnly}
                        hover={hover}
                        setHover={setHover}
                        setVal={setVal}
                        setFormData={setFormData}
                        title={options ? options[i] : false}
                    />
                ))}
            </div>
            {activeTitle ? <div className={css.title}>{activeTitle}</div> : null}
        </div>
    );
};
export default Stars;
